import { fork, all } from 'redux-saga/effects';
import { watchApiTask } from 'app/sagas';
import { api } from 'app/api';
import * as actions from './reportApplicationDetailsActions';

export const getESGradeByGroupTask = watchApiTask(
  actions.GET_ESGRADE_BY_GROUP,
  api.post,
  '/evaluation-system/getESGradeByGroup.php',
);

export const getESGradeByStudentTask = watchApiTask(
  actions.GET_ESGRADE_BY_STUDENT,
  api.post,
  '/evaluation-system/getESGradeByStudent.php',
);

export const getEvaluationTask = watchApiTask(
  actions.GET_EVALUATION,
  api.post,
  '/evaluation-system/getEvaluationInformation.php',
);

export const getFiltersLevelApplicationReportTask = watchApiTask(
  actions.GET_FILTERS_LEVEL_APPLICATION_REPORT,
  api.post,
  '/evaluation-system/getFiltersLevelApplicationReport.php',
);

export const getDetailEvaluationAlternativesTask = watchApiTask(
  actions.GET_DETAIL_EVALUATION_ALTERNATIVES,
  api.post,
  '/evaluation-system/getDetailEvaluationAlternatives.php',
);

export const getESGradeQuestionsDetailTask = watchApiTask(
  actions.GET_ESGRADE_QUESTIONS_DETAIL,
  api.post,
  '/evaluation-system/getESGradeQuestionsDetail.php',
);

export const getESQuestionDetailTask = watchApiTask(
  actions.GET_ES_QUESTION_DETAIL,
  api.post,
  '/evaluation-system/getESQuestionDetail.php',
);

export const getFiltersQuestionsApplicationReportTask = watchApiTask(
  actions.GET_FILTERS_QUESTIONS_APPLICATION_REPORT,
  api.post,
  '/evaluation-system/getFiltersQuestionsApplicationReport.php',
);

export const getFilterReportsTask = watchApiTask(
  actions.GET_FILTERS_REPORTS,
  api.post,
  '/evaluation-system/getFilterReports.php',
);

export const getESGradeByRankingStudentTask = watchApiTask(
  actions.GET_ESGRADE_BY_RANKING_STUDENT,
  api.post,
  '/evaluation-system/getESGradeByRankingStudent.php',
);

export const getESFiltersComponentsTask = watchApiTask(
  actions.GET_ES_FILTERS_COMPONENTS,
  api.post,
  '/evaluation-system/getESFiltersComponents.php',
);

export const getESGradeByDisciplineTask = watchApiTask(
  actions.GET_ESGRADE_BY_DISCIPLINE,
  api.post,
  '/evaluation-system/getESGradeByDiscipline.php',
);

export const getESQuestionsDetailsByComponentsTask = watchApiTask(
  actions.GET_ES_QUESTIONS_DETAILS_BY_COMPONENTS,
  api.post,
  '/evaluation-system/getESQuestionsDetailsByComponents.php',
);

export const getESGradeByAbilityTask = watchApiTask(
  actions.GET_ESGRADE_BY_ABILITY,
  api.post,
  '/evaluation-system/getESGradeByAbility.php',
);

export const getESGradeReportStudentTask = watchApiTask(
  actions.GET_ESGRADE_REPORT_STUDENT,
  api.post,
  '/evaluation-system/getESGradeReportStudent.php',
);

export const getESGradeDetailByStudentTask = watchApiTask(
  actions.GET_ESGRADE_DETAIL_BY_STUDENT,
  api.post,
  '/evaluation-system/getESGradeDetailByStudent.php',
);

export const getESGradeDetailAlternativeReportTask = watchApiTask(
  actions.GET_ESGRADE_DETAIL_ALTERNATIVE_REPORT,
  api.post,
  '/evaluation-system/getESGradeDetailAlternativeReport.php',
);

export const getESEvaluationsCicleStudentTask = watchApiTask(
  actions.GET_ES_EVALUATIONS_CICLE_STUDENT,
  api.post,
  '/evaluation-system/getESEvaluationsCicleStudent.php',
);

export const getESGradeStudentQuestionsTask = watchApiTask(
  actions.GET_ESGRADE_STUDENT_QUESTIONS,
  api.post,
  '/evaluation-system/getESGradeStudentQuestions.php',
);

export const getStudentsAnswersQuestionReportTask = watchApiTask(
  actions.GET_STUDENTS_ANSWERS_QUESTION_REPORT,
  api.post,
  'evaluation-system/getStudentsAnswersQuestionReport.php',
);

export const getEssaySsoUrlTask = watchApiTask(
  actions.GET_ESSAY_SSO_URL,
  api.post,
  '/evaluation-system/generateEssaySsoUrl.php',
);

export const getESGradeComparativeByStudentTask = watchApiTask(
  actions.GET_ESGRADE_COMPARATIVE_BY_STUDENT,
  api.post,
  '/evaluation-system/getESGradeComparativeByStudent.php',
);

// Root module saga
export function* sagas() {
  yield all([
    fork(getESGradeByGroupTask),
    fork(getESGradeByStudentTask),
    fork(getEvaluationTask),
    fork(getFiltersLevelApplicationReportTask),
    fork(getDetailEvaluationAlternativesTask),
    fork(getESGradeQuestionsDetailTask),
    fork(getESQuestionDetailTask),
    fork(getFiltersQuestionsApplicationReportTask),
    fork(getFilterReportsTask),
    fork(getESGradeByRankingStudentTask),
    fork(getESFiltersComponentsTask),
    fork(getESGradeByDisciplineTask),
    fork(getESQuestionsDetailsByComponentsTask),
    fork(getESGradeByAbilityTask),
    fork(getESGradeReportStudentTask),
    fork(getESGradeDetailByStudentTask),
    fork(getESGradeDetailAlternativeReportTask),
    fork(getESEvaluationsCicleStudentTask),
    fork(getESGradeStudentQuestionsTask),
    fork(getStudentsAnswersQuestionReportTask),
    fork(getEssaySsoUrlTask),
    fork(getESGradeComparativeByStudentTask),
  ]);
}
